'use client';

import { cn } from '@/lib/utils';
import { useState } from 'react';
import Accordion, { IAccordion } from './Accordion';
import Button from '../ui/Button';
import { useTranslations } from 'next-intl';

const DEFAULT_VISIBLE_ACCORDIONS = 6;

export default function AccordionsBlock({
    accordions,
    white = false,
}: {
    accordions: IAccordion[];
    white?: boolean;
}) {
    const t = useTranslations();

    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const [visibleAccordions, setVisibleAccordions] = useState(DEFAULT_VISIBLE_ACCORDIONS);

    const handleShowMore = () => {
        if (visibleAccordions === DEFAULT_VISIBLE_ACCORDIONS) {
            setVisibleAccordions(accordions.length);
        } else {
            setVisibleAccordions(DEFAULT_VISIBLE_ACCORDIONS);
        }
    };

    const toggleAccordion = (index: number) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <div>
            {accordions.slice(0, visibleAccordions).map(({ title, text }, index) => (
                <Accordion
                    className={cn('mt-3', white && 'text-white border-white')}
                    title={title}
                    text={text}
                    index={index}
                    key={index}
                    isOpen={openIndex === index}
                    toggleAccordion={toggleAccordion}
                />
            ))}
            {accordions.length > DEFAULT_VISIBLE_ACCORDIONS && (
                <Button
                    variant="expand"
                    onClick={handleShowMore}
                    title={
                        visibleAccordions === DEFAULT_VISIBLE_ACCORDIONS
                            ? t('Buttons.showAll')
                            : t('Buttons.showLess')
                    }
                    isExpanded={visibleAccordions !== DEFAULT_VISIBLE_ACCORDIONS}
                />
            )}
        </div>
    );
}
